import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
// snackbar
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const AddBatch = () => {
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedTutor, setSelectedTutor] = useState("");
  const [isBatchNameTouched, setIsBatchNameTouched] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [formValues, setFormValues] = useState({
    batch_name: "",
    batch_description: "",
    batch_start_duration: "",
    batch_end_duration: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [departments, setDepartments] = useState([]);

  const [tutors, setTutors] = useState([]);
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [formError, setFormError] = useState("");
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [token, setToken] = useState("");

  const navigate = useNavigate();

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    // const token1 = localStorage.getItem("token");
    const token1 = localStorage.getItem("token");
    setToken(token1);
    if (!token1) {
      // console.log("Access required");
      return;
    }
    fetchdepartment();
  }, []);

  useEffect(() => {
    fetchTutors();
  }, [selectedDepartment]);

  useEffect(() => {
    fetchCourses();
  }, [selectedTutor, selectedDepartment]);

  const fetchdepartment = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/no-pagination-get-all-department`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setDepartments(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchTutors = async () => {
    if (!selectedDepartment) {
      return;
    }
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }

      const tutorResponse = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-tutor-bydept/${selectedDepartment}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setTutors(tutorResponse.data.data); // Update to your API structure
    } catch (error) {
      // console.log(error);
    }
  };

  // fetch courses assigned to the selected tutor form assign course
  const fetchCourses = async () => {
    if (!selectedTutor) {
      return;
    }
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }

      const courseResponse = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-course-bytutor/${selectedTutor}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setCourses(courseResponse.data.data); // Update to your API structure
    } catch (error) {
      // console.log(error);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (loading) return; // Prevent multiple submissions
    setLoading(true);

    // Check if the end date is after the start date
    if (
      new Date(formValues.batch_end_duration) <=
      new Date(formValues.batch_start_duration)
    ) {
      setFormError("End date must be after the start date.");
      setLoading(false);
      return;
    }

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }

      const response = await axios.post(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/add-batch`,
        { formValues, selectedDepartment, selectedTutor, selectedCourse },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 201) {
        setSnackbarMessage("Created successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/batch-list");
        }, 2000);
      }
    } catch (err) {
      setLoading(false);
      if (err.response && err.response.status === 402) {
        setSnackbarMessage(
          `This Batch name is already exists. Please check and update accordingly.`
        );
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
      } else if (err.response.status === 401) {
        setSnackbarMessage(`Please fill out all required fields...`);
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
      // } else if (err.response.status === 400) {
      //   setSnackbarMessage(
      //     `A batch with this department, tutor, and course already exists. Try a different combination!`
      //   );
      //   setSnackbarSeverity("warning");
      //   setOpenSnackbar(true);
      } else {
        setSnackbarMessage("Failed to create. Please try again.");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      }
    }
  };

  return (
    <div className="row gy-4">
      <div className="col-lg-8" style={styles.cardContent(loading)}>
        <div className="card h-100">
          <div className="card-body p-24">
            <form onSubmit={(e) => handleFormSubmit(e)}>
              {/* Batch Name */}
              <div className="mb-24">
                <label
                  htmlFor="batch_name"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Batch Name
                  <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className="form-control radius-8"
                  id="batch_name"
                  name="batch_name"
                  value={formValues.batch_name}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormValues({ ...formValues, batch_name: value });
                  }}
                  onBlur={() => setIsBatchNameTouched(true)}
                  placeholder="Enter Batch Name"
                  required
                />
                {/* {isBatchNameTouched && !formValues.batch_name && (
                  <small className="text-danger-600">
                    Batch name is required
                  </small>
                )} */}
              </div>

              {/* Batch Description */}
              <div className="mb-24">
                <label
                  htmlFor="batch_description"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Description
                </label>
                <input
                  type="text"
                  className="form-control radius-8"
                  id="batch_description"
                  placeholder="Enter Batch Description (optional)"
                  value={formValues.batch_description}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || value.trim() !== "") {
                      setFormValues({
                        ...formValues,
                        batch_description: e.target.value,
                      });
                    }
                  }}
                />
              </div>
              <div className="mb-24">
                <label
                  htmlFor="department"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Department
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  className="form-control radius-8 form-select"
                  id="department"
                  value={selectedDepartment || ""}
                  onChange={(e) => {
                    setSelectedDepartment(e.target.value || "");
                    setSelectedTutor("");
                    setSelectedCourse("");
                  }}
                  required
                >
                  <option value="" disabled>
                    Select a Department
                  </option>
                  {departments.map((department) => (
                    <option key={department?._id} value={department?._id}>
                      {department?.department_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-24">
                <label
                  htmlFor="tutor"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Select Tutor
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  required
                  className="form-control radius-8 form-select"
                  id="tutor"
                  value={selectedTutor || ""}
                  onChange={(e) => {
                    setSelectedTutor(e.target.value || "");
                    setSelectedCourse("");
                  }}
                >
                  <option value="" disabled>
                    Select Tutor
                  </option>
                  {tutors.length > 0 ? (
                    tutors.map((tutor) => (
                      <option key={tutor._id} value={tutor._id}>
                        {tutor?.name}
                      </option>
                    ))
                  ) : (
                    <option value="">No Tutors Available</option>
                  )}
                </select>
              </div>

              <div className="mb-24">
                <label
                  htmlFor="course"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Select Course
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  required
                  className="form-control radius-8 form-select"
                  id="course"
                  value={selectedCourse || ""}
                  onChange={(e) => {
                    setSelectedCourse(e.target.value || "");
                  }}
                >
                  <option value="" disabled>
                    Select Course
                  </option>
                  {courses.length > 0 ? (
                    courses.map((course) => (
                      <option key={course?._id} value={course?.course_id?._id}>
                        {course?.course_id?.coursename}
                      </option>
                    ))
                  ) : (
                    <option value="">No Courses Available</option>
                  )}
                </select>
              </div>

              {/* Start Date */}
            
               <div className="row">
                  <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="batch_start_duration"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Start Date <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="date"
                          required
                          className="form-control radius-8"
                          id="batch_start_duration"
                          value={formValues.batch_start_duration}
                          min={new Date().toISOString().slice(0, 16)} // Ensures correct format
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              batch_start_duration: e.target.value,
                            })
                          }
                        />
                      </div>
                  </div>
                
  
                {/* End Date */}
                <div className="col-sm-6">
                  <div className="mb-20">
                    <label
                      htmlFor="batch_end_duration"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      End Date <span className="text-danger-600">*</span>
                    </label>
                    <input
                      required
                      type="date"
                      className="form-control radius-8"
                      id="batch_end_duration"
                      value={formValues.batch_end_duration}
                      min={new Date().toISOString().split("T")[0]}
                      onChange={(e) =>
                        setFormValues({
                          ...formValues,
                          batch_end_duration: e.target.value,
                        })
                      }
                    />
                    {formError && (
                      <div className="text-danger-600">{formError}</div>
                    )}
                  </div>
                </div>
               </div>

              {/* Action Buttons */}
              <div className="d-flex align-items-center justify-content-center gap-3">
                <button
                  type="button"
                  className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                  onClick={() => navigate("/batch-list")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                  // onClick={handleFormSubmit}
                  disabled={loading}
                >
                  {loading && (
                    <div
                      className="loader-container"
                      style={styles.loaderContainer}
                    >
                      <CircularProgress />
                    </div>
                  )}
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          // variant="filled"
          // sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default AddBatch;
